/**
 * Returns true when an element has non-zero size and intersects the viewport.
 */
export const isElementVisibleInViewport = (node: HTMLElement) => {
  const rect = node.getBoundingClientRect()

  return (
    rect.width > 0 &&
    rect.height > 0 &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= window.innerHeight &&
    rect.left <= window.innerWidth
  )
}
